import {ArrowLeft, ArrowRight, Quotes} from '@phosphor-icons/react';
import {Carousel, Input} from 'antd';
import {useRef} from 'react';
import {useMediaQuery} from 'react-responsive';
import './AboutUs.less';
import {stats} from './AboutUsData';
import img from '../../assets/slider-image.jpg';
import {cardsData} from '../FAQ/homeData';
import ExpandableCards from '../../Components/ExpandableCards/ExpandableCards';
import MainFormWithSlider from '../../Components/MainFormWithSlider/MainFormWithSlider';
import TextArea from 'antd/es/input/TextArea';
import ServicesSection from '../../Components/ServicesSection/ServicesSection';
import {sliderItems} from '../Home/Home';
// import {sliderItems} from '../Home/home';
const QuoteMark = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="#0b63e5"
			width="48px"
			height="50px"
			viewBox="0 0 256 256"
			id="Flat">
			<path
				d="M108,72v72H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60A8,8,0,0,1,108,72Zm108-8H156a8,8,0,0,0-8,8v64a8,8,0,0,0,8,8h68V72A8,8,0,0,0,216,64Z"
				opacity="0.2"
			/>
			<path d="M100,56H40A16.01833,16.01833,0,0,0,24,72v64a16.01833,16.01833,0,0,0,16,16h60v8a32.036,32.036,0,0,1-32,32,8,8,0,0,0,0,16,48.05436,48.05436,0,0,0,48-48V72A16.01833,16.01833,0,0,0,100,56Zm0,80H40V72h60ZM216,56H156a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16h60v8a32.036,32.036,0,0,1-32,32,8,8,0,0,0,0,16,48.05436,48.05436,0,0,0,48-48V72A16.01833,16.01833,0,0,0,216,56Zm0,80H156V72h60Z" />
		</svg>
	);
};
const TestimonialCard = ({text, author, carouselRef}: {text: string; author: string; carouselRef: any}) => (
	<div className="about-us-services">
		<div>
			<div className="services-header">
				<p className="services-subtitle">Testimonial</p>
				<h1 className="services-title">What our client says about our services.</h1>
			</div>
			<div className="services-testimonial">
				<p className="testimonial-text">{text}</p>
				<p className="testimonial-author">
					<QuoteMark />
				</p>
			</div>
			<div className="carousel-buttons">
				<button aria-label="Previous Slide" onClick={() => carouselRef.current?.prev()}>
					<ArrowLeft size={22} color="#1C70CA" />
				</button>
				<button aria-label="Next Slide" onClick={() => carouselRef.current?.next()}>
					<ArrowRight size={22} color="#1C70CA" />
				</button>
			</div>
		</div>
	</div>
);

const StatBox = ({stat}: {stat: {number: string; text: string; bgColor: string; icon: JSX.Element}}) => (
	<div className="about-us-stat-box" style={{backgroundColor: stat.bgColor}}>
		<div className="about-us-stat-icon">{stat.icon}</div>
		<div className="about-us-stat-text-box">
			<p className="about-us-stat-number">{stat.number}</p>
			<p className="about-us-stat-text">{stat.text}</p>
		</div>
	</div>
);

const AboutUs = () => {
	const carouselRef = useRef<any>(null);
	const isMobile = useMediaQuery({maxWidth: 670});

	const testimonialItems = [
		{
			text: 'As a valued partner of ITG, we have experienced outstanding service and technical expertise in shared access solutions. Their secure and scalable infrastructure has allowed us to seamlessly connect multiple branches and streamline data exchange, enhancing both efficiency and operational security. ITG’s commitment to innovation and customer support ensures that our banking systems remain reliable and up to date. We highly appreciate their dedication and recommend ITG to any financial institution looking for advanced and secure shared access solutions.',
			author: 'Client Name'
		},
		{
			text: 'ITG has been instrumental in providing a secure and efficient shared access solution, enabling seamless connectivity across multiple locations. Their expertise in designing and implementing scalable infrastructure has significantly improved operational efficiency while maintaining top-tier security standards. With a commitment to innovation and exceptional customer support, ITG ensures that businesses can rely on stable and high-performance access solutions. Their dedication to excellence makes them a trusted partner in the financial technology sector.',
			author: 'Another Client'
		},
		{
			text: 'ITG’s Dedicated Alliance Access/Entry service has been a game-changer in ensuring seamless and secure financial transactions. Their robust and tailored solutions provide direct, uninterrupted connectivity, enhancing both efficiency and reliability in daily operations. With their expert support and cutting-edge technology, we have experienced faster processing times and strengthened security measures.',
			author: 'Another Client'
		}
	];

	return (
		<div className="about_us">
			<header className="about_us_header">
				<p className="about-us-title">About Us</p>
				<h2 className="about-us-main-heading">
					ITG is the only accredited SWIFT Service Bureau in Armenia
				</h2>
				<p className="about-us-text">
					Since our establishment in 2011, we have been dedicated to providing resilient and
					efficient solutions for accessing the full suite of SWIFT services, along with
					comprehensive technical and operational support. Our commitment to quality and security
					has made us a trusted partner for leading banks and financial institutions. 
				</p>
			</header>

			<section className="about_us_content">
				<div className="about_us_text_content">
					<h1 className="about-us-subheading">Who we are</h1>
					<h2 className="about-us-subheading-main">
						ITG is accredited SWIFT Service Bureau in Armenia
					</h2>
					<p className="about-us-description">
						“Information Technology Gateways” (ITG) is the only accredited partner of SWIFT in
						Armenia that provides banks and financial institutions with access to the complete
						range of SWIFT services with the highest possible data security and integrity. Using
						the status of the SWIFT Service Bureau, our company delivers the opportunity to
						communicate with more than 11 thousand banks and other financial institutions around
						the world and execute international financial transactions. We offer all SWIFT data
						processing and connectivity in a reliable and resilient environment with full backup,
						systems maintenance, infrastructure upgrades and on-going support with real-time
						monitoring.
					</p>
				</div>
				<div
					className="about-us-stats-container"
					style={{
						gap: 40,
						marginBottom: isMobile ? 20 : 50,
						marginTop: isMobile ? 30 : 70
					}}>
					{stats.map((stat, index) => (
						<StatBox key={index} stat={stat} />
					))}
				</div>
			</section>

			<ServicesSection />

			<section className="custom-carousel-box">
				<Carousel dots={false} ref={carouselRef}>
					{testimonialItems.map((item, index) => (
						<div key={index}>
							<TestimonialCard
								key={index}
								text={item.text}
								author={item.author}
								carouselRef={carouselRef}
							/>
						</div>
					))}
				</Carousel>
			</section>

			<footer className="about-us-contacts-box">
				<MainFormWithSlider carouselItems={sliderItems} />
			</footer>
		</div>
	);
};

export default AboutUs;
